module.exports = __webpack_public_path__ + "static/media/osviel-transparente.e0a62dbd.png";